import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';

import { Instances } from '../../../constants';
import { IStateType } from '../../../store/models/root.interface';
import { makeSelectObject } from '../../../store/Object';

import {
	requestObjects,
	changeSearchStr,
	makeSelectFilters,
} from '../../../store/Objects';

import Asset, {
	DispatchPropsType,
	MapStateToPropsType,
} from '../organisms/Assets/SeeMore';

const mapStateToProps = (state: IStateType) => ({
	data: makeSelectObject(Instances.assets)(state) || [],
	filters: makeSelectFilters(Instances.assetsDetailed)(state),
});

const mapDispatchToProps = {
	onTabChange: (currentTab: string) =>
		requestObjects(Instances.assetsDetailed, { asset: currentTab }),
	onSearchChange: (searchStr?: string) =>
		changeSearchStr(Instances.assetsDetailed, searchStr || ''),
};

export default connect<
	MapStateToPropsType,
	DispatchPropsType,
	unknown,
	IStateType
>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(Asset));
